/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppCasesRouteImport } from './routes/_app/cases'
import { Route as AppCatalogueRouteImport } from './routes/_app/catalogue'
import { Route as AppCategoriesRouteImport } from './routes/_app/categories'
import { Route as AppCustomPricingRouteImport } from './routes/_app/custom-pricing'
import { Route as AppDepositsRouteImport } from './routes/_app/deposits'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppPacksRouteImport } from './routes/_app/packs'
import { Route as AppPlatformRouteImport } from './routes/_app/platform'
import { Route as AppPromoRouteImport } from './routes/_app/promo'
import { Route as AppStatsRouteImport } from './routes/_app/stats'
import { Route as AppTransactionsRouteImport } from './routes/_app/transactions'
import { Route as AppWithdrawalsRouteImport } from './routes/_app/withdrawals'
import { Route as AppAffiliatesIndexRouteImport } from './routes/_app/affiliates/index'
import { Route as AppAffiliatesUserIdRouteImport } from './routes/_app/affiliates/$userId'
import { Route as AppCardsIndexRouteImport } from './routes/_app/cards/index'
import { Route as AppCardsDuplicatesRouteImport } from './routes/_app/cards/duplicates'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppUsersUserIdRouteImport } from './routes/_app/users/$userId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesRoute = AppCasesRouteImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogueRoute = AppCatalogueRouteImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => AppRoute,
} as any)
const AppCategoriesRoute = AppCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomPricingRoute = AppCustomPricingRouteImport.update({
  id: '/custom-pricing',
  path: '/custom-pricing',
  getParentRoute: () => AppRoute,
} as any)
const AppDepositsRoute = AppDepositsRouteImport.update({
  id: '/deposits',
  path: '/deposits',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppPacksRoute = AppPacksRouteImport.update({
  id: '/packs',
  path: '/packs',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformRoute = AppPlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => AppRoute,
} as any)
const AppPromoRoute = AppPromoRouteImport.update({
  id: '/promo',
  path: '/promo',
  getParentRoute: () => AppRoute,
} as any)
const AppStatsRoute = AppStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsRoute = AppTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AppRoute,
} as any)
const AppWithdrawalsRoute = AppWithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => AppRoute,
} as any)
const AppAffiliatesIndexRoute = AppAffiliatesIndexRouteImport.update({
  id: '/affiliates/',
  path: '/affiliates/',
  getParentRoute: () => AppRoute,
} as any)
const AppAffiliatesUserIdRoute = AppAffiliatesUserIdRouteImport.update({
  id: '/affiliates/$userId',
  path: '/affiliates/$userId',
  getParentRoute: () => AppRoute,
} as any)
const AppCardsIndexRoute = AppCardsIndexRouteImport.update({
  id: '/cards/',
  path: '/cards/',
  getParentRoute: () => AppRoute,
} as any)
const AppCardsDuplicatesRoute = AppCardsDuplicatesRouteImport.update({
  id: '/cards/duplicates',
  path: '/cards/duplicates',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/cases': typeof AppCasesRoute
  '/catalogue': typeof AppCatalogueRoute
  '/categories': typeof AppCategoriesRoute
  '/custom-pricing': typeof AppCustomPricingRoute
  '/deposits': typeof AppDepositsRoute
  '/inbox': typeof AppInboxRoute
  '/packs': typeof AppPacksRoute
  '/platform': typeof AppPlatformRoute
  '/promo': typeof AppPromoRoute
  '/stats': typeof AppStatsRoute
  '/transactions': typeof AppTransactionsRoute
  '/withdrawals': typeof AppWithdrawalsRoute
  '/affiliates/$userId': typeof AppAffiliatesUserIdRoute
  '/cards/duplicates': typeof AppCardsDuplicatesRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/affiliates/': typeof AppAffiliatesIndexRoute
  '/cards/': typeof AppCardsIndexRoute
  '/users/': typeof AppUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/cases': typeof AppCasesRoute
  '/catalogue': typeof AppCatalogueRoute
  '/categories': typeof AppCategoriesRoute
  '/custom-pricing': typeof AppCustomPricingRoute
  '/deposits': typeof AppDepositsRoute
  '/inbox': typeof AppInboxRoute
  '/packs': typeof AppPacksRoute
  '/platform': typeof AppPlatformRoute
  '/promo': typeof AppPromoRoute
  '/stats': typeof AppStatsRoute
  '/transactions': typeof AppTransactionsRoute
  '/withdrawals': typeof AppWithdrawalsRoute
  '/': typeof AppIndexRoute
  '/affiliates/$userId': typeof AppAffiliatesUserIdRoute
  '/cards/duplicates': typeof AppCardsDuplicatesRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/affiliates': typeof AppAffiliatesIndexRoute
  '/cards': typeof AppCardsIndexRoute
  '/users': typeof AppUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/cases': typeof AppCasesRoute
  '/_app/catalogue': typeof AppCatalogueRoute
  '/_app/categories': typeof AppCategoriesRoute
  '/_app/custom-pricing': typeof AppCustomPricingRoute
  '/_app/deposits': typeof AppDepositsRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/packs': typeof AppPacksRoute
  '/_app/platform': typeof AppPlatformRoute
  '/_app/promo': typeof AppPromoRoute
  '/_app/stats': typeof AppStatsRoute
  '/_app/transactions': typeof AppTransactionsRoute
  '/_app/withdrawals': typeof AppWithdrawalsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/affiliates/$userId': typeof AppAffiliatesUserIdRoute
  '/_app/cards/duplicates': typeof AppCardsDuplicatesRoute
  '/_app/users/$userId': typeof AppUsersUserIdRoute
  '/_app/affiliates/': typeof AppAffiliatesIndexRoute
  '/_app/cards/': typeof AppCardsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/cases'
    | '/catalogue'
    | '/categories'
    | '/custom-pricing'
    | '/deposits'
    | '/inbox'
    | '/packs'
    | '/platform'
    | '/promo'
    | '/stats'
    | '/transactions'
    | '/withdrawals'
    | '/affiliates/$userId'
    | '/cards/duplicates'
    | '/users/$userId'
    | '/affiliates/'
    | '/cards/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/cases'
    | '/catalogue'
    | '/categories'
    | '/custom-pricing'
    | '/deposits'
    | '/inbox'
    | '/packs'
    | '/platform'
    | '/promo'
    | '/stats'
    | '/transactions'
    | '/withdrawals'
    | '/'
    | '/affiliates/$userId'
    | '/cards/duplicates'
    | '/users/$userId'
    | '/affiliates'
    | '/cards'
    | '/users'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/cases'
    | '/_app/catalogue'
    | '/_app/categories'
    | '/_app/custom-pricing'
    | '/_app/deposits'
    | '/_app/inbox'
    | '/_app/packs'
    | '/_app/platform'
    | '/_app/promo'
    | '/_app/stats'
    | '/_app/transactions'
    | '/_app/withdrawals'
    | '/_app/'
    | '/_app/affiliates/$userId'
    | '/_app/cards/duplicates'
    | '/_app/users/$userId'
    | '/_app/affiliates/'
    | '/_app/cards/'
    | '/_app/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases': {
      id: '/_app/cases'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof AppCasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalogue': {
      id: '/_app/catalogue'
      path: '/catalogue'
      fullPath: '/catalogue'
      preLoaderRoute: typeof AppCatalogueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/categories': {
      id: '/_app/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AppCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custom-pricing': {
      id: '/_app/custom-pricing'
      path: '/custom-pricing'
      fullPath: '/custom-pricing'
      preLoaderRoute: typeof AppCustomPricingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deposits': {
      id: '/_app/deposits'
      path: '/deposits'
      fullPath: '/deposits'
      preLoaderRoute: typeof AppDepositsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/packs': {
      id: '/_app/packs'
      path: '/packs'
      fullPath: '/packs'
      preLoaderRoute: typeof AppPacksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform': {
      id: '/_app/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof AppPlatformRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/promo': {
      id: '/_app/promo'
      path: '/promo'
      fullPath: '/promo'
      preLoaderRoute: typeof AppPromoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stats': {
      id: '/_app/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof AppStatsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions': {
      id: '/_app/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AppTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/withdrawals': {
      id: '/_app/withdrawals'
      path: '/withdrawals'
      fullPath: '/withdrawals'
      preLoaderRoute: typeof AppWithdrawalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/affiliates/': {
      id: '/_app/affiliates/'
      path: '/affiliates'
      fullPath: '/affiliates/'
      preLoaderRoute: typeof AppAffiliatesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/affiliates/$userId': {
      id: '/_app/affiliates/$userId'
      path: '/affiliates/$userId'
      fullPath: '/affiliates/$userId'
      preLoaderRoute: typeof AppAffiliatesUserIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cards/': {
      id: '/_app/cards/'
      path: '/cards'
      fullPath: '/cards/'
      preLoaderRoute: typeof AppCardsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cards/duplicates': {
      id: '/_app/cards/duplicates'
      path: '/cards/duplicates'
      fullPath: '/cards/duplicates'
      preLoaderRoute: typeof AppCardsDuplicatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$userId': {
      id: '/_app/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AppUsersUserIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCasesRoute: typeof AppCasesRoute
  AppCatalogueRoute: typeof AppCatalogueRoute
  AppCategoriesRoute: typeof AppCategoriesRoute
  AppCustomPricingRoute: typeof AppCustomPricingRoute
  AppDepositsRoute: typeof AppDepositsRoute
  AppInboxRoute: typeof AppInboxRoute
  AppPacksRoute: typeof AppPacksRoute
  AppPlatformRoute: typeof AppPlatformRoute
  AppPromoRoute: typeof AppPromoRoute
  AppStatsRoute: typeof AppStatsRoute
  AppTransactionsRoute: typeof AppTransactionsRoute
  AppWithdrawalsRoute: typeof AppWithdrawalsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAffiliatesUserIdRoute: typeof AppAffiliatesUserIdRoute
  AppCardsDuplicatesRoute: typeof AppCardsDuplicatesRoute
  AppUsersUserIdRoute: typeof AppUsersUserIdRoute
  AppAffiliatesIndexRoute: typeof AppAffiliatesIndexRoute
  AppCardsIndexRoute: typeof AppCardsIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCasesRoute: AppCasesRoute,
  AppCatalogueRoute: AppCatalogueRoute,
  AppCategoriesRoute: AppCategoriesRoute,
  AppCustomPricingRoute: AppCustomPricingRoute,
  AppDepositsRoute: AppDepositsRoute,
  AppInboxRoute: AppInboxRoute,
  AppPacksRoute: AppPacksRoute,
  AppPlatformRoute: AppPlatformRoute,
  AppPromoRoute: AppPromoRoute,
  AppStatsRoute: AppStatsRoute,
  AppTransactionsRoute: AppTransactionsRoute,
  AppWithdrawalsRoute: AppWithdrawalsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAffiliatesUserIdRoute: AppAffiliatesUserIdRoute,
  AppCardsDuplicatesRoute: AppCardsDuplicatesRoute,
  AppUsersUserIdRoute: AppUsersUserIdRoute,
  AppAffiliatesIndexRoute: AppAffiliatesIndexRoute,
  AppCardsIndexRoute: AppCardsIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
